"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var TextArea = function TextArea(_ref) {
  var label = _ref.label,
    required = _ref.required,
    placeholder = _ref.placeholder,
    name = _ref.name,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    children = _ref.children,
    value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    alert = _ref.alert,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-input margin-bottom-sm"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label margin-bottom-sm",
    htmlFor: id || label.replace(/\s+/g, '-').toLowerCase(),
    "data-section": "form-label"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative"
  }, /*#__PURE__*/_react["default"].createElement("textarea", {
    className: "form-control ".concat(className),
    required: required,
    "data-section": "form-control",
    placeholder: placeholder,
    "aria-invalid": invalid,
    disabled: disabled,
    name: name,
    id: id || label.replace(/\s+/g, '-').toLowerCase(),
    value: value,
    onChange: onChange,
    "aria-label": label,
    title: label
  }, children)), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-top-sm",
    show: alert.showNotification,
    text: alert.notificationMessage,
    type: alert.notificationType,
    onClose: alert.onClose
  }));
};
TextArea.propTypes = {
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  children: _propTypes["default"].any,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  alert: _propTypes["default"].object,
  className: _propTypes["default"].string
};
TextArea.defaultProps = {
  required: false,
  alert: null
};
var _default = exports["default"] = TextArea;